import {styled} from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import {useI18n} from 'store/Store'
import Texts from 'appearance/texts'
import Button from 'components/Control/Button'
import FormDatePicker from 'components/Control/Form/FormDatePicker'
import {Page, PageContent} from 'components/Page'
import useUploadFilmedDatesForm from 'logic/Forms/useUploadFilmedDatesForm'
import FilesWaitingForUpload from './FilesWaitingForUpload'
import YoutubeUploadStatus from './YoutubeStatus/YoutubeUploadStatus'

const UploadFilmedDates = () => {
    const {i18n} = useI18n()

    const {control, errors, status, isUpload, submit} =
        useUploadFilmedDatesForm()

    return (
        <Page>
            <PageContent>
                <Container>
                    <Texts.Title>
                        {i18n.t('dances.uploadFullFilmedDate')}
                    </Texts.Title>
                    <Texts.RegularText>
                        {i18n.t('upload.processStatus', {
                            status,
                        })}
                    </Texts.RegularText>

                    <InputWrapper>
                        <FormDatePicker
                            name="filmedDate"
                            label={i18n.t(`dances.filmedDate`)}
                            control={control}
                            error={errors.filmedDate}
                            timezone="UTC"
                        />

                        <Button
                            variant="contained"
                            style={{height: '39px', gap: 0, width: '120px'}}
                            startIcon={<FileUploadIcon />}
                            onClick={submit}
                            loading={isUpload}>
                            {i18n.t('upload.uploadButton')}
                        </Button>
                    </InputWrapper>

                    <FilesWaitingForUpload />

                    <YoutubeUploadStatus />
                </Container>
            </PageContent>
        </Page>
    )
}

export default UploadFilmedDates

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 12px;
`

const InputWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 50%;
`
